import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { filter, first, switchMap } from "rxjs/operators";
import { DialogResult } from "src/app/common/dialog/dialog.component";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { DocumentFacade } from "src/app/services/document.facade";
import { StepFacade } from "src/app/step/services/step.facade";
import {
  IDefaultStepPayloadData,
  IDocument,
  Step
} from "../../../../interfaces";
import { LogClass, Logger } from "../../../../logger";
import { NavigationService } from "../../../../services";

@Component({
    selector: "circ-work",
    templateUrl: "./work.component.html",
    styleUrls: ["./work.component.scss"],
    standalone: false
})
@LogClass({ source: "forInformation/WorkComponent" })
export class WorkComponent implements OnInit {
  public comment: string;
  public loading = true;
  public title: string;
  public disabled = false;
  public form: FormGroup;
  public addDocumentsDialogOpened = false;
  private logger: Logger;
  private step: Step;
  private documents: IDocument[];

  constructor(
    private stepFacade: StepFacade,
    private circulationFacade: CirculationFacade,
    private documentFacade: DocumentFacade,
    private navigate: NavigationService
  ) {
    this.logger.debug("ctor");
    this.createForm();
  }
  public onAddDocumentsDialogClosed(result: DialogResult): void {
    if (result !== DialogResult.Yes) {
      this.navigateToCurrentCirculation();
      return;
    }
    this.save();
  }
  public confirm(): void {
    if (
      this.step.props.permissions.canAddDocuments &&
      (this.documents == null || this.documents?.length == 0)
    ) {
      this.addDocumentsDialogOpened = true;
    } else {
      this.save();
    }
  }
  public save(): void {
    this.disabled = true;
    this.loading = true;
    this.stepFacade
      .complete(this.step, {
        result: "Confirmed",
        comment: this.form.value.workComment || ""
      })
      .pipe(first())
      .subscribe(
        () => {
          this.loading = false;
          this.navigateToCurrentCirculation();
        },
        (e) => {
          this.navigate.toError(e);
        }
      );
  }
  private navigateToCurrentCirculation(): void {
    this.navigate.toCirculation(this.step.props.circulationId);
  }

  public ngOnInit(): void {
    const circulation$ = this.circulationFacade
      .getCurrentCirculation()
      .pipe(filter((c) => !!c));

    circulation$
      .pipe(
        switchMap(() => this.stepFacade.getCurrentStep()),
        filter((s) => !!s),
        first()
      )
      .subscribe((step) => {
        if (!step) {
          this.navigate.toError("step not found");
        }
        if (step.props.status !== "InProgress") {
          this.navigate.toError(
            "can not work on step with status: " + step.props.status
          );
        }
        this.step = step;
        if (this.step.props.permissions.canAddDocuments) {
          this.documentFacade
            .getForCirculation(this.step.props.circulationId)
            .pipe(
              filter((s) => !!s),
              first()
            )
            .subscribe((doc) => {
              this.documents = doc.filter(
                (x) => x.stepNo == this.step.props.stepNo
              );
            });
        }

        const data = step.props.payload.data as IDefaultStepPayloadData;
        this.title = data?.title;
        this.comment = data?.comment;
        this.loading = false;
      });
  }

  private createForm() {
    this.form = new FormGroup({
      workComment: new FormControl("")
    });
  }
}
